export * from '@firebase/analytics';
//# sourceMappingURL=index.esm.js.map
